import script from "./about.vue?vue&type=script&setup=true&lang=ts"
export * from "./about.vue?vue&type=script&setup=true&lang=ts"

import "./about.vue?vue&type=style&index=0&id=68e95f15&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68e95f15"]])

export default __exports__